/**
 *
 * DeleteUserPopup
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 14-Dec-2022
 */

import React from 'react';
import PropTypes from 'prop-types';
import PortalModal from 'Components/PortalModal/PortalModal';
import formattedMessage from '../../modules/languageModule';
import style from './DeleteUserPopup.scss';

const DeleteUserPopup = (props) => (
	<PortalModal
		title={formattedMessage.warning}
		subtitle={formattedMessage.subtitleDelete}
		subtitleValues={formattedMessage.deleteSubtitle}
		actions={() => {}}
		buttons={[
			{
				variant: 'outlined',
				onClick: props.actions.closeModal,
				contentText: formattedMessage.abortLabelButton,
			},
			{
				variant: 'contained',
				onClick: () => props.actions.deleteUser(props.payload),
				contentText: formattedMessage.confirmLabelButton,
				isLoading: props.isLoading,
			},
		]}
	/>
);

DeleteUserPopup.propTypes = {
	// Add here some propTypes
	actions: PropTypes.objectOf(PropTypes.func),
	isLoading: PropTypes.bool,
	payload: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
};

DeleteUserPopup.defaultProps = {
	// Add here some default propTypes values
	actions: {},
	isLoading: false,
};
export default DeleteUserPopup;
